import React from "react";
import { Button, Modal } from "react-bootstrap";
import { convertTo12Hour, formatPhoneNumber } from "./bookingStepperUtils";

// The dialogs around the form: the "not enough availability" notice, the order confirmation,
// "discard changes?" and the "online payments are not enabled" notice. Moved from Bookings.jsx.
function BookingModals({ b }) {
  const {
    calenderMessage,
    setCalenderMessage,
    showOrderConf,
    onHideOrderConf,
    group_id,
    modelData,
    isSportsService,
    currency,
    showCancelConfirm,
    setShowCancelConfirm,
    navigate,
    showOnlineDisabledModal,
    setShowOnlineDisabledModal,
    setSelectedPayment
  } = b;

  return (
    <>
      <Modal className="flex-center calendarMessage" show={!!calenderMessage} centered onHide={() => setCalenderMessage("")}>
        <div onClick={() => setCalenderMessage("")} className="closeCalender" role="button" aria-label="Close">
          X
        </div>
        <div style={{ padding: "1rem" }}>{calenderMessage}</div>
      </Modal>

      <Modal
        show={showOrderConf}
        onHide={onHideOrderConf}
        centered
        size="xl"
        backdrop="static"
        dialogClassName="custom-appointment-modal addServiceModal"
        contentClassName="rounded-4 border-0"
      >
        <h4 className="text-center text-danger p-2 pb-0 ">{group_id ? `Order Updated` : `Order Confirmation`}</h4>

        <hr className="mx-4 my-0" />

        <Modal.Body className="px-4 py-4">
          <div className="d-flex flex-column gap-2">
            {/* Rows with no value are dropped so empty labels don't show. */}
            {[
              { label: "Order ID", value: modelData?.booking_id },
              {
                label: "Selected Service",
                value: [
                  ...new Set(
                    modelData?.serviceData
                      ?.filter((ele) => ele.added)
                      ?.map((ele) => ele?.service_name)
                      .filter(Boolean)
                  )
                ].join(", ")
              },
              {
                label: "Selected Service Subcategory",
                value: [
                  ...new Set(
                    modelData?.serviceData
                      ?.filter((ele) => ele.added && ele?.service_type_name && ele.service_type_name !== "null")
                      ?.map((ele) => ele?.service_type_name)
                  )
                ].join(", ")
              },
              {
                label: "Selected Type",
                value: modelData?.serviceData
                  ?.filter((ele) => ele.added)
                  ?.map((ele) => ele?.service_offering_name)
                  .filter(Boolean)
                  .join(", ")
              },
              { label: "Service Location", value: modelData?.state },
              {
                label: "Scheduled Date & Time",
                value: modelData?.date ? `${modelData.date}${modelData?.time ? ` @ ${convertTo12Hour(modelData.time)}` : ""}` : ""
              },
              modelData?.lat &&
                modelData?.lng && {
                  label: "Google Map Link",
                  value: (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://www.google.com/maps/search/?api=1&query=${modelData?.lat},${modelData?.lng}`}
                    >
                      {`https://www.google.com/maps/search/?api=1&query=${modelData?.lat},${modelData?.lng}`}
                    </a>
                  )
                },
              {
                label: "Address",
                value: [modelData?.house_no, modelData?.area, modelData?.location, modelData?.landmark, modelData?.state]
                  .filter((part) => part && String(part).trim() && part !== "null")
                  .join(", ")
              },
              { label: isSportsService ? "Player Name" : "Customer Name", value: modelData?.userName },
              {
                label: isSportsService ? "Player Contact" : "Customer Contact",
                value: modelData?.phoneNumber ? formatPhoneNumber(modelData.phoneNumber, currency) : ""
              }
            ]
              .filter((row) => row && row.value !== null && row.value !== undefined && String(row.value).trim() !== "")
              .map((row) => (
                <div key={row.label} className="d-flex align-items-start">
                  <div className="label" style={{ width: "180px", flexShrink: 0 }}>
                    {row.label}
                  </div>
                  <div style={{ width: "10px" }}>:</div>
                  <div style={{ flex: 1, wordBreak: "break-word" }}>{row.value}</div>
                </div>
              ))}
          </div>
        </Modal.Body>
        <div className="d-flex justify-content-center align-items-center mb-2">
          <button className="btn btn-danger rounded " onClick={onHideOrderConf}>
            Close
          </button>
        </div>
      </Modal>

      <Modal
        show={showCancelConfirm}
        onHide={() => setShowCancelConfirm(false)}
        centered
        size="sm"
        backdrop="static"
        contentClassName="rounded-4 border-0"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-6 fw-bold">Discard changes?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2 pb-3">
          <p className="mb-0 text-muted" style={{ fontSize: "14px" }}>
            You have unsaved input. Leaving now will discard all changes.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0">
          <Button variant="outline-secondary" onClick={() => setShowCancelConfirm(false)} style={{ minWidth: 100 }}>
            Stay
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setShowCancelConfirm(false);
              navigate(-1);
            }}
            style={{ minWidth: 100 }}
          >
            Discard &amp; Leave
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showOnlineDisabledModal} onHide={() => setShowOnlineDisabledModal(false)} centered size="sm" contentClassName="rounded-4 border-0">
        <Modal.Body className="pt-4">
          <p className="mb-3" style={{ fontSize: 15, lineHeight: 1.5 }}>
            Contact System Admin to enable this capability
          </p>
          <Button
            variant="danger"
            className="w-100"
            onClick={() => {
              setSelectedPayment("cash");
              setShowOnlineDisabledModal(false);
            }}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BookingModals;
